export {default} from './TeamsVolumeSummaryCard.connect';
